import { MapShell } from '../map/MapShell.js';
import { MapControls } from '../map/MapControls.js';
import { Instruments } from './Instruments.js';
import { TopBar } from './TopBar.js';
import { TrailLayer } from './TrailLayer.js';
import { PredictorLayer } from './PredictorLayer.js';
import { MeasureLayer } from './MeasureLayer.js';
import { LoggerChip } from '../tracks/LoggerChip.js';
import { ShareChip } from '../share/ShareChip.js';
import { FollowRouteLayer } from '../route/FollowRouteLayer.js';
import { FollowBanner } from '../route/FollowBanner.js';
import { useFollowStore } from '../route/followStore.js';
import { GotoLayer } from '../goto/GotoLayer.js';
import { AisLayer } from '../ais/AisLayer.js';
import { useWakeLock } from './useWakeLock.js';
import './navigate.css';

export function NavigateScreen(): JSX.Element {
  // Position watch + recorder run app-wide (started in main); the map keeps the
  // screen awake while it's the visible view.
  useWakeLock();
  const following = useFollowStore((s) => s.route != null);

  return (
    <div className="navigate">
      <MapShell>
        <TrailLayer />
        <PredictorLayer />
        <TopBar />
        <LoggerChip />
        <ShareChip />
        {following && (
          <>
            <FollowRouteLayer />
            <FollowBanner />
          </>
        )}
        <GotoLayer />
        <AisLayer />
        <MeasureLayer />
        <MapControls />
      </MapShell>
      <Instruments />
    </div>
  );
}
